import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMAIL_REGEX } from '@core/enums/patterns';
import { ISubscriber } from '@core/interfaces/imailing-list';
import { IModalData } from '@core/interfaces/imodal-data';
import { MailingListService } from '@core/services/mailing-list.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-welcome-modal',
    templateUrl: './welcome-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WelcomeModalComponent {
  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private mailingList: MailingListService,
    private toastr: ToastrService,
  ) {}

  @Input() data!: IModalData;
  welomeForm!: FormGroup | any;
  formPayload!: ISubscriber;

  get email() {
    return this.welomeForm.get('email');
  }

  ngOnInit(): void {
    this.initializeForms();
  }

  initializeForms(): void {
    this.welomeForm = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(EMAIL_REGEX)]],
    });
  }

  submit(form: ISubscriber): void {
    this.formPayload = form;
    this.mailingList.addSubscriber(this.formPayload).subscribe((res: any) => {
      if (res) {
        this.toastr.success(
          'Thank you for subscribing! Please check your email.'
        );
        this.activeModal.close();
      }
    });
    this.welomeForm.reset();
  }

  closeModal() {
    this.activeModal.close();
  }
}
